
<template>
  <div class="container" style="min-height: 400px;">
    <div class="col-lg-12">
      <ul class="nav nav-tabs">
        <li class="nav-item"><a href="" data-target="#tabtopic" data-toggle="tab" class="nav-link active">Topic</a></li>
        <li class="nav-item"><a href="" data-target="#topicposts" data-toggle="tab" class="nav-link">Topic Posts</a></li>
        <li class="nav-item"><a href="" data-target="#homepage" data-toggle="tab" class="nav-link">Home</a></li>
        <li class="nav-item"><a href="" data-target="#relevant" data-toggle="tab" class="nav-link">Relevant</a></li>
        <li class="nav-item"><a href="" data-target="#posts" data-toggle="tab" class="nav-link">Posts</a></li>
        <li class="nav-item"><a href="" data-target="#caches" data-toggle="tab" class="nav-link">Caches</a></li>
      </ul>
      <div class="tab-content py-4">

        <div class="tab-pane active" id="tabtopic">
          <div class="row">
            <div class="col-md-12">
              <h5 class="mb-3">Add topic</h5>
              <form role="form" @submit.prevent="addTopic">
                <div 
                  v-if="submitted && message" 
                  class="alert" 
                  :class="successful ? 'alert-success' : 'alert-danger'" 
                  role="alert">{{message}}</div>
                <div class="form-group row">
                  <div class="col-lg-12" style="margin-bottom: 10px;">
                    <input class="form-control" type="text" placeholder="Name topic"
                      name="nameTopic"
                      v-model="nameTopic" 
                      v-validate="'required|min:1|max:200'"
                      :class="submitted && errors.has('nameTopic') ? 'is-invalid' : (submitted ? 'is-valid' : '')"
                    >
                    <span v-if="submitted && errors.has('nameTopic')" class="help-block">{{errors.first('nameTopic')}}</span>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-lg-12">
                    <button class="btn btn-outline-primary btn-sm" type="submit" :disabled="loading">
                      <span v-show="loading" class="spinner-border spinner-border-sm"></span> <span>Add</span>
                    </button>
                  </div>
                </div>
              </form>
              <hr>
            </div>
            <div class="col-md-12">
              <h5 class="mb-3">List Topics</h5>
              <div class="table-responsive">
                <div 
                  v-if="esubmitted && emessage" 
                  class="alert" 
                  :class="esuccessful ? 'alert-success' : 'alert-danger'" 
                  role="alert">{{emessage}}</div>
                <table class="table table-fixed">
                  <thead>
                    <tr>
                      <th scope="col" class="col-7">Name</th>
                      <th scope="col" class="col-2">Status</th>
                      <th scope="col" class="col-3">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="topics.length > 0">
                    <tr v-for="t in topics" :key="t.id">
                      <td v-if="editting === t.id" scope="row" class="col-7">
                        <input v-model="editNameTopic" name="editNameTopic" type="text" placeholder="Name topic" style="width: 100%;" />
                      </td>
                      <td v-else scope="row" class="col-7">{{t.name}}</td>
                      <td v-if="editting === t.id" class="col-2">
                        <select v-model="editStatusTopic">
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      </td>
                      <td v-else class="col-2"><span :class="t.status === 'Active' ? 'text-success' : 'text-secondary'">{{t.status}}</span></td>
                      <td v-if="editting === t.id" class="col-3">
                        <div class="d-none d-md-block">
                          <button @click.prevent="cancelTopic(t)" :disabled="eloading" type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px;">Cancel</button>
                          <button @click.prevent="saveTopic(t)" :disabled="eloading" type="button" class="btn btn-outline-success btn-sm">Save</button>
                        </div>
                        <div class="d-md-none">
                          <button @click.prevent="cancelTopic(t)" :disabled="eloading" type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px;"><font-awesome-icon icon="times" /></button>
                          <button @click.prevent="saveTopic(t)" :disabled="eloading" type="button" class="btn btn-outline-success btn-sm"><font-awesome-icon icon="arrow-down" /></button>
                        </div>
                      </td>
                      <td v-else class="col-3">
                        <div class="d-none d-md-block">
                          <button @click.prevent="editTopic(t)" :disabled="eloading" type="button" class="btn btn-outline-primary btn-sm" style="margin-right: 5px;">Edit</button>
                          <button @click.prevent="deleteTopic(t)" :disabled="eloading" type="button" class="btn btn-outline-danger btn-sm">Delete</button>
                        </div>
                        <div class="d-md-none">
                          <button @click.prevent="editTopic(t)" :disabled="eloading" type="button" class="btn btn-outline-primary btn-sm" style="margin-right: 5px;"><font-awesome-icon icon="edit" /></button>
                          <button @click.prevent="deleteTopic(t)" :disabled="eloading" type="button" class="btn btn-outline-danger btn-sm"><font-awesome-icon icon="trash" /></button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr><td colspan="3" class="col-12">Data topic empty</td></tr>
                  </tbody>
                </table>
              </div>
              <hr>
            </div>
          </div>
        </div>

        <div class="tab-pane" id="topicposts">
          <h5 class="mb-3">Add post into topic</h5>
          <form role="form" @submit.prevent="addTopicPosts">
            <div 
              v-if="submitted && message" 
              class="alert" 
              :class="successful ? 'alert-success' : 'alert-danger'" 
              role="alert">{{message}}</div>
            <div class="form-group row">
              <div class="col-lg-12">
                <b-form-select v-model="selectTopic" :options="optionsTopics" @change="changeSelectTopic"></b-form-select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-12">
                <treeselect
                  v-model="selectedPosts"
                  :options="optionsPosts"
                  :multiple="true"
                  :flatten-search-results="true"
                  placeholder="Select list posts"
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-12">
                <button class="btn btn-outline-primary" type="submit" :disabled="loading">
                  <span v-show="loading" class="spinner-border spinner-border-sm"></span> <span>Save</span>
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="tab-pane" id="homepage">
          <h5 class="mb-3">Add topic into home page</h5>
          <form role="form" @submit.prevent="addHomeTopics">
            <div 
              v-if="submitted && message" 
              class="alert" 
              :class="successful ? 'alert-success' : 'alert-danger'" 
              role="alert">{{message}}</div>
            <div class="form-group row">
              <div class="col-lg-12">
                <treeselect
                  v-model="selectedTopics"
                  :options="optionsHomeTopics"
                  :multiple="true"
                  :flatten-search-results="true"
                  placeholder="Select list topics"
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-12">
                <button class="btn btn-outline-primary" type="submit" :disabled="loading">
                  <span v-show="loading" class="spinner-border spinner-border-sm"></span> <span>Save</span>
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="tab-pane" id="relevant">
          <h5 class="mb-3">Add relevant post</h5>
          <form role="form" @submit.prevent="addRelevantPosts">
            <div 
              v-if="submitted && message" 
              class="alert" 
              :class="successful ? 'alert-success' : 'alert-danger'" 
              role="alert">{{message}}</div>
            <div class="form-group row">
              <div class="col-lg-12">
                <b-form-select v-model="selectPost" :options="optionsMainPosts" @change="changeSelectMainPost"></b-form-select>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-12">
                <treeselect
                  v-model="selectedRelevantPosts"
                  :options="optionsRelevantPosts"
                  :multiple="true"
                  :flatten-search-results="true"
                  placeholder="Select list posts"
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-12">
                <button class="btn btn-outline-primary" type="submit" :disabled="loading">
                  <span v-show="loading" class="spinner-border spinner-border-sm"></span> <span>Save</span>
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="tab-pane" id="posts">
          <h5 class="mb-3">Management Posts</h5>
          <form role="form" @submit.prevent="onOffPost">
            <div 
              v-if="submitted && message" 
              class="alert" 
              :class="successful ? 'alert-success' : 'alert-danger'" 
              role="alert">{{message}}</div>
            <div class="form-group row">
              <div class="col-lg-12">
                <treeselect
                  v-model="selectedManaPost"
                  :options="optionsPosts"
                  :multiple="false"
                  :flatten-search-results="true"
                  placeholder="Select a post"
                  @select="changeSelectManaPost"
                />
              </div>
            </div>
            <div class="form-group row">
              <div class="col-lg-12">
                <button v-if="selectedManaPost" class="btn" type="submit" :class="onOffManaPost==='On' ? 'btn-outline-success' : 'btn-outline-danger'" :disabled="loading">
                  <span v-show="loading" class="spinner-border spinner-border-sm"></span> <span>{{onOffManaPost}} post</span>
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="tab-pane" id="caches">
          <h5 class="mb-3">Management Caches</h5>
          <form role="form" @submit.prevent="refreshSearchCache">
            <div 
              v-if="submitted && message" 
              class="alert" 
              :class="successful ? 'alert-success' : 'alert-danger'" 
              role="alert">{{message}}</div>
            <div class="form-group row">
              <div class="col-lg-12">
                <button class="btn btn-outline-danger" type="submit" :disabled="loading">
                  <span v-show="loading" class="spinner-border spinner-border-sm"></span> <span>Refresh search cache</span>
                </button>
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import AdminService from "../services/admin.service";
import PostService from "../services/post.service";
import UserService from "../services/user.service";

export default {
  name: 'Admin',
  components: {
    
	},
  data() {
    return {
      // Add Topic
      submitted: false,
      loading: false,
      successful: false,
      message: '',
      nameTopic: '',
      // Update & Delete Topic
      editting: null,
      esubmitted: false,
      eloading: false,
      esuccessful: false,
      emessage: '',
      editNameTopic: '',
      editStatusTopic: '',
      // Update ListPost of Topic
      topics: [],
      allPosts: [],
      selectTopic: null,
      optionsTopics: [{ value: null, text: 'Please select a topic' }],
      optionsPosts: [],
      selectedPosts: [],
      // Home Page
      homeTopics: [],
      optionsHomeTopics: [],
      selectedTopics: [],
      // Relevant
      selectPost: null,
      optionsMainPosts: [{ value: null, text: 'Please select a post' }],
      optionsRelevantPosts: [],
      selectedRelevantPosts: [],
      // Management Posts
      selectedManaPost: null,
      onOffManaPost: '',
    };
  },
  computed: {
    currentUser() {
			return this.$store.state.auth.user;
		},
    isAdmin() {
			if(this.currentUser && this.currentUser.role) {
				return this.currentUser.role == 'ADqrumXT2ga' || this.currentUser.role == 'RKxqtbyt58d';
			}
			return false;
		},
  },
  created () {
    if(!this.isAdmin) {
      this.$router.push('/');
      return;
    }
    // checkToken
		this.checkToken();
		// fetch the data when the view is created and the data is already being observed
		// https://router.vuejs.org/guide/advanced/data-fetching.html
    this.fetchData();
  },
  methods: {
    checkToken() {
			// console.log("In checkToken Admin");
			if(this.currentUser) {
				UserService.checkToken().then(data => {
					// console.log(data);
					if(data && data.err < 0) {
						this.$store.dispatch('auth/logout');
						window.location.reload();
					}
				});
			}
		},
    fetchData() {
      this.getAllTopic();
      this.getAllPosts();
      this.getHomeTopics();
    },
    getAllTopic() {
      // console.log("In getAllTopic");
      AdminService.getAllTopic().then(data => {
        // console.log('=============== Set List Data Topics ===============');
        // console.log(data);
        if(data && data.err >= 0) {
          // Tab Add Topic
          this.topics = data.topics;
          // Tab Topic Posts & Home Page 
          for(let i = 0; i < this.topics.length; i++) {
            let t = this.topics[i];
            let optp = {"value": t.id, "text": t.name + " [" +t.status+ "]"};
            // Tab Topic Posts
            this.optionsTopics = [...this.optionsTopics, optp];
            // Tab Home Page
            let opth = {"id": t.id, "label": t.name + " [" +t.status+ "]"};
            this.optionsHomeTopics = [...this.optionsHomeTopics, opth];
          }
        }
      });
    },
    getAllPosts() {
      // console.log("In getAllPosts");
      PostService.getAllPosts().then(data => {
        // console.log('=============== Set List Data allPosts ===============');
        // console.log(data);
        if(data && data.err >= 0) {
          this.allPosts = data.allPosts;
          for(let i = 0; i < this.allPosts.length; i++) {
            let p = this.allPosts[i];
            let optp = {"id": p.id, "label": p.title + " ["+p.status+"]"};
            this.optionsPosts = [...this.optionsPosts, optp];
            let optr = {"value": p.id, "text": p.title + " ["+p.status+"]"};
            this.optionsMainPosts = [...this.optionsMainPosts, optr];
          }
        }
      });
    },
    resetAddTopic() {
      this.submitted = false;
      this.loading = false;
      this.successful = false;
      this.message = '';
    },
    addTopic() {
      // console.log("In addTopic");
      this.$validator.validateAll().then(isValid => {
        // console.log("isValid: " + isValid);
        this.submitted = true;
        this.loading = true;
        if(isValid) {
          let formData = {
            "action": "addTopic",
            "name": this.nameTopic
          };
          AdminService.addTopic(formData).then(data => {
            this.message = data.msg;
            if(data && data.err >= 0) {
              this.successful = true;
              // add new topic to this.topics data
              let t = {
                "id": data.id,
                "name": this.nameTopic,
                "status": "Active",
                "postIds": []
              };
              this.topics = [...this.topics, t];
              // Tab Topic Posts
              let optp = {"value": t.id, "text": t.name + " [" + t.status + "]"};
              this.optionsTopics = [...this.optionsTopics, optp];
              // Tab Home Page
              let opth = {"id": t.id, "label": t.name + " [" + t.status + "]"};
              this.optionsHomeTopics = [...this.optionsHomeTopics, opth];
              setTimeout(() => {
                this.resetAddTopic();
              }, 2000);
            } else {
              this.successful = false;
              this.loading = false;
            }
          });
        } else {
          this.loading = false;
        }
      });
    },
    resetEditTopic() {
      this.esubmitted = false;
      this.eloading = false;
      this.esuccessful = false;
      this.emessage = '';
      this.editting = null;
      this.editNameTopic = '';
      this.editStatusTopic = '';
    },
    editTopic(topic) {
      // console.log("In editTopic: " + topic.name);
      this.editting = topic.id;
      this.editNameTopic = topic.name;
      this.editStatusTopic = topic.status;
    },
    cancelTopic() {
      // console.log("In cancelTopic: " + topic.name);
      this.editting = null;
      this.editNameTopic = '';
      this.editStatusTopic = '';
    },
    validateUpdateTopic() {
      if(0 < this.editNameTopic.length && this.editNameTopic.length < 200 && this.editStatusTopic.length > 0) {
        return true;
      }
      this.emessage = "Name topic invalid";
      return false;
    },
    saveTopic(topic) {
      // console.log("In saveTopic: " + topic.name);
      this.esubmitted = true;
      this.eloading = true;
      this.emessage = "";
      // console.log("isValid: " + this.validateUpdateTopic());
      if(this.validateUpdateTopic()) {
        let formData = {
          "action": "updateTopic",
          "id": topic.id,
          "name": this.editNameTopic,
          "status": this.editStatusTopic,
          "postIds": JSON.stringify(topic.postIds)
        };
        AdminService.updateTopic(formData).then(data => {
          this.emessage = data.msg;
          if(data && data.err >= 0) {
            this.esuccessful = true;
            // update topic to this.topics data
            let t = topic;
            t.name = this.editNameTopic;
            t.status = this.editStatusTopic;
            this.topics = this.topics.map(tp => tp.id === topic.id ? t : tp);
            // Tab Topic Posts
            let optp = {"value": t.id, "text": t.name + " [" + t.status + "]"};
            this.optionsTopics = this.optionsTopics.map(op => op.value === topic.id ? optp : op);
            // Tab Home Page
            let opth = {"id": t.id, "label": t.name + " [" + t.status + "]"};
            this.optionsHomeTopics = this.optionsHomeTopics.map(op => op.value === topic.id ? opth : op);
            setTimeout(() => {
              this.resetEditTopic();
            }, 2000);
          } else {
            this.esuccessful = false;
            this.eloading = false;
          }
        });
      } else {
        this.eloading = false;
      }
    },
    deleteTopic(topic) {
      // console.log("In deleteTopic: " + topic.name);
      this.confirmDeleteTopic(topic);
    },
    confirmDeleteTopic(topic) {
      // console.log('In confirmDeleteTopic: ' + topic.name);
      this.$bvModal.msgBoxConfirm('Are you want to delete this topic ['+topic.name+'] ?', {
        title: 'Delete Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        // console.log('confirmDeleteTopic: ' + value);
        if(value) { // Confirm OK
          let formData = {
            "id": topic.id,
            "action": "deleteTopic"
          };
          AdminService.deleteTopic(formData).then(data => {
            // console.log(data);
            if(data && data.err >= 0) {
              // delete data in vue: this.topics
              this.topics = this.topics.filter(tp => tp.id !== topic.id);
              // delete select topic
              this.optionsTopics = this.optionsTopics.filter(op => op.value !== topic.id);
              // Tab Home Page
              this.optionsHomeTopics = this.optionsHomeTopics.filter(op => op.id !== topic.id);
            }
          });
        }
      }).catch(err => {
        // An error occurred
        console.log(err);
      })
    },
    getTopic(id){
      return this.topics.find(tp => tp.id === id);
    },
    changeSelectTopic() {
      // console.log("In changeSelectTopic: " + this.selectTopic);
      this.selectedPosts = [];
      if(this.selectTopic != null) {
        let tp = this.getTopic(this.selectTopic);
        // console.log(tp);
        this.selectedPosts = tp.postIds;
      } else {
        this.selectedPosts = [];
      }
    },
    resetAddTopicPosts() {
      this.submitted = false;
      this.loading = false;
      this.successful = false;
      this.message = '';
      this.selectTopic = null;
      this.selectedPosts = [];
    },
    addTopicPosts() {
      // console.log("In addTopicPosts");
      this.submitted = true;
      if(this.selectTopic == null) {
        this.message = "Select topic is required";
        this.successful = false;
        setTimeout(() => {this.message = "";}, 3000);
        return;
      }
      let topic = this.getTopic(this.selectTopic);
      if(!topic) {
        this.message = "Topic is not found";
        this.successful = false;
        setTimeout(() => {this.message = "";}, 3000);
        return;
      }
      this.loading = true;
      let formData = {
        "action": "updateTopic",
        "id": topic.id,
        "name": topic.name,
        "status": topic.status,
        "postIds": JSON.stringify(this.selectedPosts)
      };
      AdminService.updateTopic(formData).then(data => {
        this.message = data.msg;
        if(data && data.err >= 0) {
          this.successful = true;
          // update topic to this.topics data
          let t = topic;
          t.postIds = this.selectedPosts;
          this.topics = this.topics.map(tp => tp.id === topic.id ? t : tp);
          setTimeout(() => {
            this.resetAddTopicPosts();
          }, 2000);
        } else {
          this.successful = false;
          this.loading = false;
        }
      });
    },
    resetAddHomeTopics() {
      this.submitted = false;
      this.loading = false;
      this.successful = false;
      this.message = '';
    },
    addHomeTopics() {
      // console.log("In addHomeTopics");
      this.submitted = true;
      this.loading = true;
      let formData = {
        "action": "addHome",
        "topicIds": JSON.stringify(this.selectedTopics)
      };
      AdminService.addHomeTopics(formData).then(data => {
        // console.log(data);
        this.message = data.msg;
        if(data && data.err >= 0) {
          this.successful = true;
          setTimeout(() => {
            this.resetAddHomeTopics();
          }, 2000);
        } else {
          this.successful = false;
        }
      });
    },
    getHomeTopics() {
      // console.log("In getHomeTopic");
      AdminService.getHomeTopics().then(data => {
        // console.log(data);
        if(data && data.err >= 0) {
          this.homeTopics = data.homeTopics;
          this.selectedTopics = data.homeTopics;
        }
      });
    },
    changeSelectMainPost() {
      // console.log("In changeSelectMainPost: " + this.selectPost);
      if (this.selectPost != null) {
        this.optionsRelevantPosts = this.optionsPosts.filter(op => op.id !== this.selectPost);
        let p = this.allPosts.find(pt => pt.id === this.selectPost);
        this.selectedRelevantPosts = p.relevant;
      } else {
        this.optionsRelevantPosts = [];
        this.selectedRelevantPosts = [];
      }
    },
    resetRelevantPosts() {
      this.submitted = false;
      this.loading = false;
      this.successful = false;
      this.message = '';
      this.selectPost = null;
      this.optionsRelevantPosts = [];
      this.selectedRelevantPosts = [];
    },
    addRelevantPosts() {
      // console.log("In addRelevantPosts");
      this.submitted = true;
      if(this.selectPost == null) {
        this.message = "Select post is required";
        this.successful = false;
        setTimeout(() => {this.message = "";}, 3000);
        return;
      }
      let post = this.allPosts.find(pt => pt.id === this.selectPost);
      if(!post) {
        this.message = "Post is not found";
        this.successful = false;
        setTimeout(() => {this.message = "";}, 3000);
        return;
      }
      this.loading = true;
      let formData = {
        "action": "relevantPost",
        "id": post.id,
        "relevant": JSON.stringify(this.selectedRelevantPosts)
      };
      PostService.savePost(formData).then(data => {
        // console.log(data);
        this.message = data.msg;
        if(data && data.err >= 0) {
          this.successful = true;
          // update post to this.allPosts data
          let p = post;
          p.relevant = this.selectedRelevantPosts;
          this.allPosts = this.allPosts.map(pt => pt.id === post.id ? p : pt);
          setTimeout(() => {this.resetRelevantPosts();}, 2000);
        } else {
          this.successful = false;
          this.loading = false;
        }
      });
    },
    resetOnOffPost() {
      this.submitted = false;
      this.loading = false;
      this.successful = false;
      this.message = '';
      this.selectedManaPost = null;
      this.onOffManaPost = "";
    },
    getPost(id) {
      return this.allPosts.find(pt => pt.id === id);
    },
    changeSelectManaPost(node) {
      // console.log(node);
      // console.log("In changeSelectManaPost: " + node.id);
      if(node.id) {
        let p = this.getPost(node.id);
        this.onOffManaPost = p.status === "Active" ? "Off" : "On";
      } else {
        this.onOffManaPost = "";
      }
    },
    onOffPost() {
      // console.log("In onOffPost");
      this.submitted = true;
      if(!this.selectedManaPost) {
        this.message = "Select post is required";
        this.successful = false;
        setTimeout(() => {this.message = "";}, 3000);
        return;
      }
      let p = this.getPost(this.selectedManaPost);
      if(p) {
        this.confirmOnOffPost(p);
      }
    },
    confirmOnOffPost(p) {
      // console.log('In confirmOnOffPost');
      // console.log(p);
      this.$bvModal.msgBoxConfirm('Are you want to '+this.onOffManaPost+' this post?', {
        title: 'Update Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        // console.log('confirmOnOffPost: ' + value);
        if(value) { // Confirm OK
          this.loading = true;
          let st = p.status === "Active" ? "Delete" : "Active";
          let formData = {
            "id": this.selectedManaPost,
            "action": "statusPost",
            "status": st
          };
          PostService.statusPost(formData).then(data => {
            // console.log(data);
            if(data && data.err >= 0) {
              // update data in vue: this.allPosts
              p.status = st;
              this.allPosts = this.allPosts.map(pt => pt.id === this.selectedManaPost ? p : pt);
              // update select Posts
              let optext = p.title + " [" + st + "]";
              let op1 = {"id": p.id, "label": optext};
              this.optionsPosts = this.optionsPosts.map(op => op.id === this.selectedManaPost ? op1 : op);
              let op2 = {"value": p.id, "text": optext};
              this.optionsMainPosts = this.optionsMainPosts.map(op => op.value === this.selectedManaPost ? op2 : op);
              setTimeout(() => {this.resetOnOffPost();}, 2000);
            } else {
              this.successful = false;
              this.loading = false;
            }
          });
        }
      }).catch(err => {
        // An error occurred
        console.log(err);
      })
    },
    resetCache() {
      this.submitted = false;
      this.loading = false;
      this.successful = false;
      this.message = '';
    },
    refreshSearchCache() {
      // console.log("In resfreshSearchCache");
      this.submitted = true;
      this.loading = true;
      let formData = {
        "action": "search"
      };
      AdminService.refreshSearchCache(formData).then(data => {
        // console.log(data);
        this.message = data.msg;
        if(data && data.err >= 0) {
          this.successful = true;
          setTimeout(() => {this.resetCache();}, 2000);
        } else {
          this.successful = false;
          this.loading = false;
        }
      });
    },
  }
}
</script>

<style scoped>
.table-fixed tbody {
  height: 300px;
  overflow-y: auto;
  width: 100%;
}
.table-fixed thead,
.table-fixed tbody,
.table-fixed tr,
.table-fixed td,
.table-fixed th {
  display: block;
}
.table-fixed tbody td,
.table-fixed tbody th,
.table-fixed thead > tr > th {
  float: left;
  position: relative;
}
.table-fixed tbody td {
  font-size: 0.8rem;
}
</style>